/**
 * Switch Content
 *
 * @param currentTab The current tab
 * @param newTab The new tab
 */


function switchHoapTabs(currentTab, newTab) {
  currentTab.removeClass('active-tab');
  currentTab.addClass('inactive-tab');

  newTab.removeClass('inactive-tab');
  newTab.addClass('active-tab');
}

function switchHoapAccordions(currentAccordion, newAccordion) {
    currentAccordion.addClass('hide-accordion');
    newAccordion.removeClass('hide-accordion');
}

jQuery(document).ready(function($) {
    /**
     * Variables
     */
    const hamburger = $('.hamburger:not(.ups-hamburger)');
    const upsHamburger = $('.ups-hamburger');
    const nav = $('.menu-all');
    const header = $('.header');

    const navSearch = $('.nav-search');
    const upsSearch = $('#mobile-ups-search');
    const openSearch = $('.open-search');
    const openUpsSearch = $('.open-ups-search');
    const magnify = $('.open-search .magnify');
    const close = $('.open-search .close');
    const searchInput = $('#enter-search');

    const algoliaAutocomplete = $('.algolia-autocomplete');

    /**
     * Accordion
     */
    $('.main-click-accordion').on('click', function() {
        const plusMinus = $(this).find('.expandable');
        const sectionTitle = $(this).find('.section-title');
        if (plusMinus.hasClass('plus')) {
            $(this).next().slideDown();
            plusMinus.removeClass('plus');
            plusMinus.addClass('minus');
            sectionTitle.addClass('active');
        } else if (plusMinus.hasClass('minus')) {
            $(this).next().slideUp();
            plusMinus.removeClass('minus');
            plusMinus.addClass('plus');
            sectionTitle.removeClass('active');
        }
    });

    /**
     * Hamburger
     */

    hamburger.on('click', function() {
        if (hamburger.hasClass('is-active')) {
            nav.slideUp(700, function() {
                hamburger.removeClass('is-active').attr('aria-expanded', false);
                header.removeClass('menu-show');
            });
            //enable scrolling on body
            $('body').css('overflow', 'auto');
        } else {
            openSearch.removeClass('is-open');

            navSearch.slideUp(400, function() {
                close.fadeOut(100, function() {
                    magnify.fadeIn();
                });

                header.addClass('menu-show');
                hamburger.addClass('is-active').attr('aria-expanded', true);

                nav.delay(100).slideDown(700);
            });
            //disable scrolling on body
            $('body').css('overflow', 'hidden');
        }
    });


    upsHamburger.on('click', function() {
        if (upsHamburger.hasClass('is-active')) {
            nav.slideUp(500, function() {
                upsHamburger.removeClass('is-active').attr('aria-expanded', false);
                header.removeClass('menu-show');
            });
        } else if(upsSearch.length) {
            openUpsSearch.removeClass('is-open');

            upsSearch.slideUp(400, function() {
                close.fadeOut(100, function() {
                    magnify.fadeIn();
                });

                header.addClass('menu-show');
                upsHamburger.addClass('is-active').attr('aria-expanded', true);

                nav.delay(100).slideDown(700);
            });

        } else {
            close.fadeOut(100, function() {
                magnify.fadeIn();
            });

            header.addClass('menu-show');
            upsHamburger.addClass('is-active').attr('aria-expanded', true);

            nav.delay(100).slideDown(500);
        }
    });

    /**
     * Search
     */
    openSearch.on('click keypress', function(e) {
        const keycode = (e.keyCode ? e.keyCode : e.which);
        if (keycode === 13 || keycode === 1) {
            if (navSearch.is(':visible')) {
                close.fadeOut(100, function() {
                    magnify.fadeIn();
                });

                navSearch.slideUp(700, function() {
                    openSearch.removeClass('is-open').attr('aria-expanded', false);
                    header.removeClass('menu-show');
                });

                algoliaAutocomplete.hide();
            } else if (navSearch.is(':hidden')) {
                hamburger.removeClass('is-active');

                nav.slideUp(400, function() {
                    magnify.fadeOut(100, function() {
                        close.fadeIn();
                        searchInput.focus();
                    });

                    openSearch.addClass('is-open').attr('aria-expanded', true);
                    header.addClass('menu-show');

                    navSearch.delay(100).slideDown(700, function() {
                        if (keycode === 13) {
                            searchInput.focus();
                        }
                    });

                });


            }
        }
    });


    /**
     * Mobile UPS Search
     */
    openUpsSearch.on('click keypress', function(e) {
        const keycode = (e.keyCode ? e.keyCode : e.which);

        if (keycode === 13 || keycode === 1) {
            if (upsSearch.is(':visible')) {
                close.fadeOut(100, function() {
                    magnify.fadeIn();
                });

                upsSearch.slideUp(500, function() {
                    openUpsSearch.removeClass('is-open').attr('aria-expanded', false);
                    header.removeClass('menu-show');
                });

                algoliaAutocomplete.hide();
            } else if (upsSearch.is(':hidden')) {
                upsHamburger.removeClass('is-active');

                nav.slideUp(400, function() {
                    magnify.fadeOut(100, function() {
                        close.fadeIn();
                        searchInput.focus();
                    });

                    openUpsSearch.addClass('is-open').attr('aria-expanded', true);
                    header.addClass('menu-show');

                    upsSearch.delay(100).slideDown(500, function() {
                        if (keycode === 13) {
                            searchInput.focus();
                        }
                    });

                });


            }
        }
    });

    /**
     * Lazy Load
     *
     * What"s happening here is that you call slice() as if it was a function of NodeList using call().
     * What slice() does in this case is create an empty array, then iterate through the object it"s
     * running on (originally an array, now a NodeList) and keep appending the elements of that object
     * to the empty array it created, which is eventually returned.
     *
     * https://shifteleven.com/articles/2007/06/28/array-like-objects-in-javascript/
     */
    const lazyImages = [].slice.call(document.querySelectorAll('img.lazy'));

    lazyImages.forEach(function(lazyImage) {
        lazyImage.src = lazyImage.dataset.src;
        if (typeof lazyImage.dataset.srcset !== 'undefined') {
            lazyImage.srcset = lazyImage.dataset.srcset;
        }
        lazyImage.classList.remove('lazy');
    });

    const lazyBackgrounds = [].slice.call(document.querySelectorAll('.lazy-background'));
    lazyBackgrounds.forEach(function(lazyBackground) {
        lazyBackground.style.backgroundImage = `url(${lazyBackground.dataset.src})`;
        lazyBackground.classList.remove('lazy-background');
    });

    /**
     * HOAP Tabs-Accordion
     */

    const forLenders = $('#for-lenders');
    const forBorrowers = $('#for-borrowers');

    const forLendersAccordion = $('#for-lenders-accordion');
    const forBorrowersAccordion = $('#for-borrowers-accordion');

    forLenders.on('click', function(e) {
        switchHoapTabs(forBorrowers, forLenders);
        switchHoapAccordions(forBorrowersAccordion, forLendersAccordion);
    });
    forBorrowers.on('click', function(e) {
        switchHoapTabs(forLenders, forBorrowers);
        switchHoapAccordions(forLendersAccordion, forBorrowersAccordion);
    });

    /**
     * Ali g: Elementor accordions default to having the top accordion open. There is some code that we can add
     * that makes them all closed by default. Please ask Jordana, she's done this on other sites :)
     *
     * Jordana: yes I have done that, though it was in a pretty janky way
     */
    if ($('.elementor-tab-title').length) {
        setTimeout(function() {
            $(
                '.elementor-tab-title:not("#for-lenders-accordion .elementor-tab-title, #for-borrowers-accordion .elementor-tab-title")',
            ).removeClass('elementor-active');
            $(
                '.elementor-tab-content:not("#for-lenders-accordion .elementor-tab-content, #for-borrowers-accordion .elementor-tab-content")',
            ).css('display', 'none');
        }, 100);
    }

	$(window).scroll(function() {
		const header = $('header.front-page');
		const scrollTop = $(document).scrollTop();
		if (scrollTop !== 0) {
			header.addClass('not-at-top');
		} else {
			header.removeClass('not-at-top');
		}
	});

    /**
     * Because of the fixed header, we need to adjust for when an anchor link is used.
     */
    $(window).on('hashchange load', function () {
        // don't do this on UPS chapters
        if ($('body.single-ups-chapter')) { return; }

        const $anchor = $(':target');
        const fixedElementHeight = 160;

        if ($anchor.length > 0) {

            $('html, body')
            .stop()
            .animate({
                scrollTop: $anchor.offset().top - fixedElementHeight
            }, 280);

        }
    });

    /**
     * Refresh iFrame on page load
     */
    $('#mort01, #mort02, #mort03, #webinars-register').attr( 'src', function ( i, val ) { return val; });

    /**
     * UPS - sticky sidebar
     * https://abouolia.github.io/sticky-sidebar/
     */

    // first check if the sidebar element exists and the function is available
    if ($('#sidebar').length && $().stickySidebar() ) {
      $('#sidebar').stickySidebar({
        containerSelector: '#ups-content-wrapper',
        innerWrapperSelector: '.ups-nav-inner-wrapper',
        topSpacing() {
          return $( '.header-menu-ups-condensed' ).height();
        },
        bottomSpacing() {
          return $( '#footer' ).height();
        },
        minWidth: 529
      });

    }

    if ( $('body').hasClass('single-ups-chapter') ) {
    /**
     * UPS - navigation url hash based on scroll position
     */

      const header_height = $( '.header-menu-ups-condensed' ).height();
      const window_height = $( window ).height();

      // add scroll listener
      $( document ).on('scroll', function() {
        const currentHash = window.location.hash;

        // find the top-most header with an id
        const id = getHighestHeadingID();
        const hash = `#${ id }`;

        if (currentHash != hash) {
            history.replaceState({}, '', hash);

            // style the nav item with that hash
            const $navItem = $('.ups-menu-wrap a[href$="' + hash + '"]');

            if ($navItem.length) {

                // console.log('found hash target', $navItem)

                $('.ups-menu-wrap a').removeClass('menu-scroll-target')
                $navItem.addClass('menu-scroll-target')
                // $navItem.css('color', 'red')

                // find the parent's previous neighbour and open it
                //   $navItem.closest('.current-menu-parent').addClass('open').find('.sub-menu:hidden').show();
                //   return false;
            }
        }



      });

      function getHighestHeadingID() {

        let last_id = '';
        let return_id = '';

        $('.ups-column-main .inner-content').find('h2, h3, h4, h5, h6').each(function () {
            const id = $(this).attr('id');
            // no id - skip to the next one
            if (!id) return true;

            // get distance from element to top of window
            const top = window.pageYOffset;
            const distance = $(this).offset().top - top;

            // return first element on page
            if ( distance > header_height && distance < window_height ) {
              last_id = id;
              return_id = last_id;
              return false;
            }
            // if no element on page, return the last element above the page top
            if ( distance < window_height && !return_id ) {
              last_id = id;
            }
            if ( distance > window_height ) {
              return_id = last_id;
              return false;
            }
        });

        return return_id;

      }



      /**
       * UPS - menu accordion toggle
       */
        $('.single-ups-chapter .ups-menu-wrap .ups-sub-menu-toggle').on('click', function(e) {
        e.preventDefault();
        // console.log('open thing')

        // get the ul to open it
        $(this).closest('li').toggleClass('open');
        $(this).closest('a').siblings('.sub-menu').slideToggle();

      });


      /**
       * UPS - listener for mobile contents toggle
       */
      $('#ups-contents-header').on('click', function() {
        $(this).toggleClass('open');
        $('#menu-ups-navigation').slideToggle();
      });


      /**
       * Content accordion
       */
      // get the list of h2 elements that are accordions

      const $section_headings = $('.inner-content h2');

      $section_headings.each(function() {
        const $h2 = $(this);

        // get all the elements until the next h2
        const $section_content = $h2.nextUntil('h2');

        // if there are any h3s, turn it into an accordion
        const $h3s = $section_content.filter('h3');

        if ($h3s.length > 0) {
          // make a new element and put the content into it.
          $section_content.wrapAll('<div class="ups-accordion-section" />');

          // make it into an accordion
          $h2.addClass('ups-accordion-button').attr('tabindex', 0).on('click', function() {
            // find the next sibling section and open it.
            $(this).toggleClass('open').next('.ups-accordion-section').slideToggle();

          });

        }


      });


      function openAccordionWithHash(hash) {
        const $target = $(hash);

        if ($target.length) {

            // if it's a title: find the next neighbour and open it
            if ($target.is('h2')){
                $target.addClass('open').next('.ups-accordion-section').show();
            }

            // find the parent's previous neighbour and open it
            $target.closest('.ups-accordion-section:hidden').prev('h2').addClass('open').next('.ups-accordion-section').show();
            return false;
        }
      }

        function openNavigationWithUrl(url) {
            const $target = $('a[href^="' + url + '"]');

            if ($target.length) {

                // console.log('openNavigationWithUrl', $target)

                // find the parent's previous neighbour and open it
                $target.closest('.ups-menu-wrap>li>ul>.menu-item-has-children').addClass('open').find('.sub-menu:hidden').show();
                return false;
            }
        }

      function scrollToHash(hash) {
        setTimeout(function () {
          const element = document.getElementById(hash.replace('#', ''));
            element.scrollIntoView({ behavior: "smooth" });
        } , 500);
      }


        function highlightSearchTerm() {
            const url = window.location
            const hash = window.location.hash
            const params = new URLSearchParams(url.search)
            const highlight = params.get('highlight')

            // console.log('highlight search term', highlight)
            if (!highlight) return;

            let highlights = highlight.split(',')

            // find the element with the hash id

            let $target = $(hash)

            // when no hash is found, just start from the top of the article body
            if (!$target.length > 0) {
                $target = $('.inner-content:first-child')
            }

            // console.log('highlight target', $target)

            let searching = true

            while (searching == true && highlights.length > 0) {

                $target.each(function (i) {
                    const $el = jQuery(this)

                    // target the specific elements we want

                    let highlightTarget = ''
                    highlights.forEach(function (h) {
                        highlightTarget +=  `:contains('${h}')`
                    })
                    let highlightSelector = `h2${highlightTarget}, h3${highlightTarget}, h4${highlightTarget}, p${highlightTarget}, li${highlightTarget}, td${highlightTarget}, th${highlightTarget}`

                    if ($el.is(highlightSelector)) {
                        $el.each(function () { this.innerHTML = '<mark>' + this.innerHTML + '</mark>' })
                        searching = false
                        return;
                    }

                    let $child = $target.find(highlightSelector)

                    if ($child.length > 0) {
                        $child.each(function () { this.innerHTML = '<mark>' + this.innerHTML + '</mark>' })
                        searching = false
                        return;
                    }


                })

                $target = $target.next()
                if ($target.length == 0) {
                    searching = false
                }

            }

        }


      // toggleAccordionWithHash()

      if(window.location.hash) {
          openAccordionWithHash(window.location.hash);
          openNavigationWithUrl(window.location);
        // scrollToHash(window.location.hash)
          
      }
      highlightSearchTerm();

        $('#menu-ups-navigation a, #menu-ups-navigation-french a').on('click', function (e) {
            if (e.target.className == 'ups-sub-menu-toggle') {
                return
            }

        // get target hash
        const url = $(this).attr('href');
        const hash = url.substring(url.indexOf('#'));

        // hash is an id on this page -- open & scroll to it
        if ($(hash).length) {
          e.preventDefault()
            openAccordionWithHash(hash)
            
            var accordionDelayTimeout = setTimeout(function () { scrollToHash(hash); }, 500);
            
        }

      })

      /**
       * UPS - responsive table wrappers
       */

      $('.ups-column-main table').wrap( '<div class="responsive-table-wrapper"></div>' );

    }


    // adapted from https://codepen.io/Zu17/pen/vPyLKR
    const lightbox = $(".lightbox");
    const arrowl = $(".arrowl");
    const arrowr = $(".arrowr");

    $(".masonry-gallery .image-card").click(function() {
        lightbox.fadeIn();
        lightbox.append(`
            <div class="card-popup">
                <img src='${  $(this).find("img").attr("src")  }' alt='${  $(this).find("img").attr("alt")  }' />
                <p class="sm-font">${  $(this).find("p").text()}</p>
            </div>
        `);
        if (!$(this).find("p").text()) {
            $(".lightbox p").hide();
        }
        $(".filter").css("background-image", `url(${  $(this).attr("src")  })`);
        $("html").css("overflow", "hidden");
        if ($(this).is(":last-child")) {
            arrowr.css("display", "none");
            arrowl.css("display", "block");
        } else if ($(this).is(":first-child")) {
            arrowr.css("display", "block");
            arrowl.css("display", "none");
        } else {
            arrowr.css("display", "block");
            arrowl.css("display", "block");
        }
    });

    $(".lightbox .close").click(function() {
        $(".lightbox").fadeOut(300);
        $(".lightbox .card-popup").remove();
        $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
        if (e.keyCode === 27) {
            $(".lightbox").fadeOut(300);
            $(".lightbox .card-popup").remove();
            $("html").css("overflow", "auto");
        }
    });

    arrowr.click(function() {
        const imgSrc = $(".lightbox img").attr("src");
        const search = $(".masonry-gallery").find(`img[src$='${  imgSrc  }']`);
        const newImage = search.parent().next().find("img").attr("src");
        const newCaption = search.parent().next().find("p").text();
        // console.log({ imgSrc }, { search }, {newImage});

        if (newCaption) {
            $(".lightbox p").text(newCaption);
            $(".lightbox p").show();
        } else {
            $(".lightbox p").hide();
        }
        $(".lightbox img").attr("src", newImage);
        $(".filter").css("background-image", `url(${  newImage  })`);

        if (!search.parent().next().is(":last-child")) {
            arrowl.css("display", "block");
        } else {
            arrowr.css("display", "none");
        }
    });

    arrowl.click(function() {
        const imgSrc = $(".lightbox img").attr("src");
        const search = $(".masonry-gallery").find(`img[src$='${  imgSrc  }']`);
        const newImage = search.parent().prev().find("img").attr("src");
        const newCaption = search.parent().prev().find("p").text();

        if (newCaption) {
            $(".lightbox p").text(newCaption);
            $(".lightbox p").show();
        } else {
            $(".lightbox p").hide();
        }

        $(".lightbox img").attr("src", newImage);
        $(".filter").css("background-image", `url(${  newImage  })`);

        if (!search.parent().prev().is(":first-child")) {
            arrowr.css("display", "block");
        } else {
            arrowl.css("display", "none");
        }
    });


    // Splide Carousel and Popup modal
    if ( $('body').hasClass('page-template-template-events') ) {

        new Splide( '#image-carousel', {
            perPage    : 3,
            gap: '23px',
            breakpoints: {
                1024: {
                    perPage: 2,
                },
                640: {
                    perPage: 1,
                },
            },
        } ).mount();


        const detailsBtn = $(".splide .details-btn");
        const detailsModal = $(".details-modal");

        detailsBtn.click(function() {
            const parent = $(this).closest('.text-wrap');
            const title = parent.find('.card-title').text();
            const date = parent.find('.date').text();
            const time = parent.find('.time').text();
            const duration = parent.find('.duration').text();
            const excerpt = parent.find('.excerpt').text();
            const button = parent.find('.button').html();
            const link = parent.find('.button').attr('href');

            detailsModal.find('.title').text(title);
            detailsModal.find('.date').text(date);
            detailsModal.find('.time').text(time);
            if (duration) {
                detailsModal.find('.duration').text(`Duration: ${  duration}`);
            }
            detailsModal.find('.excerpt').text(excerpt);
            detailsModal.find('.button').html(button);
            detailsModal.find('.button').attr('href', link);

            detailsModal.css("display", "flex");
            detailsModal.hide();
            detailsModal.fadeIn();
        });

        $(".details-modal .close").click(function() {
            detailsModal.fadeOut(300);
            detailsModal.find('.duration').empty();
        });

        $(document).keyup(function(e) {
            if (e.keyCode === 27) {
                detailsModal.fadeOut(300);
                detailsModal.find('.duration').empty();
            }
        });
    }


});



